module.exports = __webpack_public_path__ + "static/media/book1.abfb5c28.png";